import { getExtranetJAPIUrl, getUcId, isDomain } from "../../utils/htmlReportsUtils";

let ROOT_PATH =
  process.env.NODE_ENV === "development" && process.env.REACT_APP_API_HOST
    ? `${
        process.env.REACT_APP_API_HOST.startsWith("uat-www") ? "https" : "http"
      }://${process.env.REACT_APP_API_HOST}/research/japi`
    : "/research/japi";

ROOT_PATH = isDomain("researchcdn.nomuranow.com") ? getExtranetJAPIUrl() : ROOT_PATH;

const ucidParam = isDomain("researchcdn.nomuranow.com") ? `?ucid=${getUcId()}` : "";
const NAIRA_SERVICE_PATH = `${ROOT_PATH}/${isDomain("researchcdn.nomuranow.com") ? "external-naira" : "naira"}`;

export const GET_RESPONSE = `${NAIRA_SERVICE_PATH}/getResponse${ucidParam}`;
export const FEEDBACK = `${NAIRA_SERVICE_PATH}/feedback${ucidParam}`;
export const UPDATE_SYS_CTX = `${NAIRA_SERVICE_PATH}/updateSysContx${ucidParam}`;
export const UPDATE_USER_CTX = `${NAIRA_SERVICE_PATH}/updateUserContx${ucidParam}`;
export const GET_SUMMARY = `${NAIRA_SERVICE_PATH}/getSummary${ucidParam}`;
export const NAIRA_DISCLAIMER_URL = `${ROOT_PATH}/${isDomain("researchcdn.nomuranow.com") ? "external-nairaTerms" : "nairaTerms"}${ucidParam}`;
export const GET_NAIRA_USER_GUIDE_URL = `${ROOT_PATH}/content/assets/static/nairaUserGuide.json${ucidParam}`;
export const GET_NAIRA_USER_ACCESS = `${NAIRA_SERVICE_PATH}/access${ucidParam}`;
export const GET_CONVERSATION_HISTORY = `${NAIRA_SERVICE_PATH}/getConversationHistory`;
export const GET_SUMMARY_PUBLICATION = (pubId) => `${NAIRA_SERVICE_PATH}/summary-publication/${pubId}${ucidParam}`;
